import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  // 首页
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/home.vue')
  },
  // 了解我们
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/about.vue')
  },
  // 招商合作
  {
    path: '/join',
    name: 'Join',
    component: () => import('../views/join.vue')
  }
]

const router = new VueRouter({
  mode: 'history', // 去掉地址栏#号
  routes,
  // 切换页面自动滚到顶部
  scrollBehavior() {
    return { y: 0 }
  }
})

export default router
